export const embargoTypes = [
  { eSpaceCode: 'open-access', value: 'OPEN_ACCESS', label: 'Open access' },
  { eSpaceCode: 'partial-embargo', value: 'PARTIAL_EMBARGO', label: 'Embargoed with author and thesis title visible' },
  { eSpaceCode: 'full-embargo', value: 'FULL_EMBARGO', label: 'Embargoed with author and thesis title not visible' },
]
